import  { useState } from "react";
//import "./studentDashboard.css";
import Sidebar from "../Dashboard/StudentDashboard/Sidebar/SideBar";
import React from "react";
// import "./Test.css";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import ReactSpeedometer from "react-d3-speedometer";
//import ChartGrowth from "./ChartGrowth"
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title);


const Dashboard = () => {
    console.log("Dashboard rendered");
     const [date, setDate] = useState(new Date());
     const handleDateChange = (date) => {
      console.log("Selected date:", date);
    };

    const onDateChange = (selectedDate) => {
      setDate(selectedDate);
    };
    const rewardsData = [
        { id: 1, title: "Level Up!", description: "Complete 10 tasks", color: "#ffe6e6" },
        { id: 2, title: "Top Performer", description: "Rank #1 in class", color: "#e6f7ff" },
        { id: 3, title: "Star Achiever", description: "Earn 500 points", color: "#fff4e6" },
        { id: 4, title: "Consistency Award", description: "Log in for 30 days", color: "#e6ffe6" },
      ];

      const chartData = {
        labels: ["Jan", "Feb", "Mar", "Apr", "May"],
        datasets: [
          {
            label: "Growth History",
            data: [20, 40, 60, 80, 70],
            backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4CAF50", "#8E44AD"],
            borderRadius: 10,
          },
        ],
      };
    
      const chartOptions = {
        responsive: true,
        plugins: {
          legend: {
            display: false,
          },
        },
      };
   
  return (
    <div class="container-scroller">
    <div class="container-fluid page-body-wrapper">
        <Sidebar/>
    <div class="main-panel">
          <div class="content-wrapper">
            <div class="row">
              <div class="col-md-12 grid-margin">
                <div class="row">
                  <div class="col-12 col-xl-8 mb-4 mb-xl-0">
                    <h3 class="font-weight-bold">Welcome User</h3>
                    <h6 class="font-weight-normal mb-0">All systems are running smoothly! You have <span class="text-primary">3 unread alerts!</span></h6>
                  </div>
                  <div class="col-12 col-xl-4">
                    <div class="justify-content-end d-flex">
                      <div class="dropdown flex-md-grow-1 flex-xl-grow-0">
                        <button class="btn btn-sm btn-light bg-white dropdown-toggle" type="button" id="dropdownMenuDate2" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                          <i class="mdi mdi-calendar"></i> Today (10 Jan 2021) </button>
                        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuDate2">
                          <a class="dropdown-item" href="#">January - March</a>
                          <a class="dropdown-item" href="#">March - June</a>
                          <a class="dropdown-item" href="#">June - August</a>
                          <a class="dropdown-item" href="#">August - November</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2 grid-margin stretch-card">
                <div class="card tale-bg" style={{backgroundColor:"light yellow"}}>
                
                  
            <h2>Cody Fisher</h2>
            <p>Student</p>
            <p>ID: 547030</p>
            <div className="contact-icons">
            <img width="100" height="100" src="https://img.icons8.com/color/100/user.png" alt="user"/>
              <span>📧</span>
              <span>📱</span>
              <span>📞</span>
            </div>
            <div className="profile-details">
              <p>Age: 17</p>
              <p>Gender: Female</p>
            </div>
            
            {/* <div className="growth-history">
            <h3>Growth History</h3>
            <Bar data={chartData} />
            
          </div>
          <br/>
          <div className="growth-history">
          <h2>Calendar</h2>
          <Calendar onChange={handleDateChange} />
            
          </div>
          <br/>
          <div className="growth-history">
          <h2>Rewards Board</h2>
            
            <div className="badges">
              <div className="badge">🏆 Level Up</div>
              <div className="badge">🎯 High Achiever</div>
              <div className="badge">🌟 Star Performer</div>
            </div>
            
          </div>
          <br/>
          <div className="growth-history">
          <h3>Class Progress</h3>
            <ReactSpeedometer
              maxValue={100}
              value={45}
              needleColor="red"
              startColor="blue"
              segments={10}
              endColor="blue"
              textColor="#000"
            />
            
          </div> */}
          
          
          
                </div>
                
              </div>
        <div class="col-md-6 grid-margin stretch-card">
          {/* <div class="card tale-bg" style={{backgroundColor:"light yellow"}}> */}
          
                  
            
            <div class="col-md-12 grid-margin transparent">
            
                <div class="row">
                  <div class="col-md-12 mb-4 stretch-card transparent">
                   
                    <div class="card card-tale">
                        
                      {/* <div class="card-body">
                        <p class="mb-4">Course</p>
                        <p class="fs-30 mb-2">XX</p>
                        <p>10.00%</p>
                      </div> */}
                      <h3>Growth History</h3>
                      <Bar data={chartData} />
                    </div>
                  </div>
                  </div>
                  {/* <div class="row">
                  <div class="col-md-4 mb-4 stretch-card transparent">
                    <div class="card">
                      
                      <h2>Calendar</h2>
                      <Calendar onChange={handleDateChange} />
                    </div>
                  </div>
                </div> */}
                <div class="row">
                  <div class="col-md-6 mb-4 mb-lg-0 stretch-card transparent">
                    <div class="card ">
                    <h2>Rewards Board</h2>
            
            <div className="badges">
              <div className="badge">🏆 Level Up</div>
              <div className="badge">🎯 High Achiever</div>
              <div className="badge">🌟 Star Performer</div>
            </div>
            
                    </div>
                    
                  </div>
                  {/* <div className="growth-history"> */}
                  <div class="col-md-6 mb-4 mb-lg-0 stretch-card transparent">
                    <div class="card-class">
                  <h3>Class Progress</h3>
            <ReactSpeedometer
              maxValue={100}
              value={45}
              needleColor="red"
              startColor="blue"
              segments={10}
              endColor="blue"
              textColor="#000"
            />
            
          </div>
          </div>
                  </div>
                  
                  
                </div>
              
            {/* <div className="growth-history">
            <h3>Growth History</h3>
            <Bar data={chartData} />
            
          </div>
          <br/>
          <div className="growth-history">
          <h2>Calendar</h2>
          <Calendar onChange={handleDateChange} />
            
          </div>
          <br/>
          <div className="growth-history">
          <h2>Rewards Board</h2>
            
            <div className="badges">
              <div className="badge">🏆 Level Up</div>
              <div className="badge">🎯 High Achiever</div>
              <div className="badge">🌟 Star Performer</div>
            </div>
            
          </div>
          <br/>
          <div className="growth-history">
          <h3>Class Progress</h3>
            <ReactSpeedometer
              maxValue={100}
              value={45}
              needleColor="red"
              startColor="blue"
              segments={10}
              endColor="blue"
              textColor="#000"
            />
            
          </div> */}
          
          
          
                {/* </div> */}
                
              </div>
              <div class="col-md-4 grid-margin transparent">
              <div class="row">
                  <div class="col-md-12 mb-4 stretch-card transparent">
                    <div class="card text-white bg-success">
                      <div class="card-body">
                        <p class="mb-4">COURSE PROGRESS</p>
                        <div class="progress">
                          <div
                            class="progress-bar progress-bar-striped progress-bar-animated bg-warning"
                            role="progressbar"
                            aria-valuenow="75"
                            aria-valuemin="0"
                            aria-valuemax="100"
                            style={{ width: "75%" }}
                          >75%</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-4 stretch-card transparent">
                    <div class="card card-tale">
                      <div class="card-body">
                        <p class="mb-4">Course</p>
                        <p class="fs-30 mb-2">XX</p>
                        <p>10.00%</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mb-4 stretch-card transparent">
                    <div class="card">
                      <div class="card-body">
                        <p class="mb-4"></p>
                        <p class="fs-30 mb-2">Assignments</p>
                        <p>22.00% (30 days)</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-4 mb-lg-0 stretch-card transparent">
                    <div class="card card-light-blue">
                      <div class="card-body">
                        <p class="mb-4">Projects</p>
                        <p class="fs-30 mb-2">34040</p>
                        <p>2.00% (30 days)</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 stretch-card transparent">
                    <div class="card card-light-danger">
                      <div class="card-body">
                        <p class="mb-4">Quiz</p>
                        <p class="fs-30 mb-2">47033</p>
                        <p>0.22% (30 days)</p>
                      </div>
                    </div>
                    
                  </div>
                  <div class="col-md-12 mb-4 stretch-card transparent">
                    <div class="card ">
                    <h2>Calendar</h2>
                      <Calendar onChange={handleDateChange} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* <div class="row">
              <div class="col-md-6 grid-margin stretch-card">
                <div class="card tale-bg" style={{backgroundColor:"light yellow"}}>
                  
                  
                <section className="center-panel">
          <div className="growth-history">
            <h3>Growth History</h3>
            <Bar data={chartData} />
          </div>

          <div className="class-progress">
            <h3>Class Progress</h3>
            <ReactSpeedometer
              maxValue={100}
              value={45}
              needleColor="red"
              startColor="blue"
              segments={10}
              endColor="blue"
              textColor="#000"
            />
          </div>
        </section>
                </div>
                
              </div>
              <div class="col-md-6 grid-margin stretch-card">
                <div class="card tale-bg" style={{backgroundColor:"light yellow"}}>
                  
                  
                <section className="center-panel">
                <div className="rewards-section">
            <h2>Rewards Board</h2>
            
            <div className="badges">
              <div className="badge">🏆 Level Up</div>
              <div className="badge">🎯 High Achiever</div>
              <div className="badge">🌟 Star Performer</div>
            </div>
          </div>

          <div className="calendar-section">
            <h2>Calendar</h2>
            <Calendar onChange={handleDateChange} />
            
            
          </div>
        </section>
                </div>
                
              </div>
              
            </div> */}
          </div>
        </div>
        </div>
        </div>
  );
};

export default Dashboard;
